var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex flex-column align-center justify-space-between",staticStyle:{"min-height":"100vh","position":"relative"},attrs:{"width":"100vw","tile":""}},[_c('v-container',{staticClass:"ma-0",attrs:{"max-width":"1200px"}},[_c('Header'),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }